export default "__VITE_ASSET__CoyZTwkX__"